(function () {
  function initSwiper(section) {
    const swiperEl = section.querySelector('.product-recommendations__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) {
      section.hidden = true;
      return;
    }

    section.hidden = false;

    new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 22,
      speed: 500,
      grabCursor: true,
      breakpoints: {
        460: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: section.querySelector('.product-recommendations__next'),
        prevEl: section.querySelector('.product-recommendations__prev'),
      },
    });
  }

  async function loadRecommendations(section) {
    const url = section.dataset.url;
    const slidesWrap = section.querySelector('[data-product-recommendations-slides]');

    if (!slidesWrap) {
      initSwiper(section);
      return;
    }

    if (url) {
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (response.ok) {
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fetchedSlides = doc.querySelector('[data-product-recommendations-slides]');

          if (fetchedSlides && fetchedSlides.children.length > 0) {
            slidesWrap.innerHTML = fetchedSlides.innerHTML;
          }
        }
      } catch {
        // Keep fallback block products when recommendations fail.
      }
    }

    initSwiper(section);
  }

  function initSection(root) {
    const section = root.matches('[data-product-recommendations]')
      ? root
      : root.querySelector('[data-product-recommendations]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';
    loadRecommendations(section);
  }

  function initAll() {
    document.querySelectorAll('[data-product-recommendations]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-product-recommendations]');
    if (section) {
      section.dataset.initialized = 'false';
      initSection(section);
    }
  });
})();
